import React, { createContext, useState } from "react";
import { useRef } from "react";
import { PAGE_LIST } from "../pages/utils/utils";

const OfferManagementContext = createContext();
export default OfferManagementContext;

export const OfferMangementProvider = (props) => {
  const [allNoOrLowCostOffers, setAllNoOrLowCostOffers] = useState([]);
  const [inputSearchData, setInputSearchData] = useState([]);
  const [offerFieldData, setOfferFieldData] = useState({})
  const [emiPlanTableData, setEmiPlanTableData] = useState();
  const [emiTypeOptions, setEmiTypeOptions] = useState([]);
  const [issuerOptions, setIssuerOptions] = useState([]);
  const [emiData, setEmiData] = useState([]);
  const [allPaymentMethods, setAllPaymentMethods] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [errorMsz, setErrorMsz] = useState('');
  const [offerDetailsById, setOfferDetailsById] = useState({});
  const [currency, setCurrency] = useState([]);

  const [pageNo, setPageNo] = useState(1);
  const [pageLimit, setPageLimit] = useState(PAGE_LIST[2]);
  const [totalDataCount, setTotalDataCount] = useState(100);
  const [callApi, setCallApi] = useState(true)

  const allIssuerRef = useRef();
  const OFFER_TYPE = [
    {
      title: 'No Cost',
      value: 'NoCostEmi'
    },
    {
      title: 'Low Cost',
      value: 'LowCostEmi'
    }
  ];
  const [selectedEMIs, setSelectedEMIs] = useState([3, 6, 9]);
  const [errorStateForOfferDetails, setErrorStateForOfferDetails] = useState({
    offerTitle: '',
    offerStartDate: '',
    offerEndDate: '',
    minAmount: '',
    maxAmount: '',
    offerDescription: ''
  });

  const resetContext = () => {
    setInputSearchData([]);
    setOfferFieldData({});
    setEmiPlanTableData();
    setEmiTypeOptions([]);
    setIssuerOptions([]);
    setEmiData([]);
    setSelectedEMIs([3, 6, 9]);
    setAllPaymentMethods([]);
    setShowModal(false);
    setErrorMsz('');
    setOfferDetailsById({});
    setCurrency([]);
    setCallApi(true)
    allIssuerRef.current = undefined;
  }

  const values = {
    allNoOrLowCostOffers, setAllNoOrLowCostOffers,
    inputSearchData,
    setInputSearchData,
    offerFieldData, setOfferFieldData,
    emiPlanTableData, setEmiPlanTableData,
    errorStateForOfferDetails, setErrorStateForOfferDetails,
    emiTypeOptions, setEmiTypeOptions,
    issuerOptions, setIssuerOptions,
    emiData, setEmiData,
    OFFER_TYPE,
    allPaymentMethods, setAllPaymentMethods,
    selectedEMIs, setSelectedEMIs,
    showModal, setShowModal,
    errorMsz, setErrorMsz,
    offerDetailsById, setOfferDetailsById,
    currency, setCurrency,
    allIssuerRef,
    resetContext,
    pageNo, setPageNo,
    pageLimit, setPageLimit,
    totalDataCount, setTotalDataCount,
    callApi, setCallApi
  };

  return (
    <OfferManagementContext.Provider value={values}>
      {props.children}
    </OfferManagementContext.Provider>
  );
};
